import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13ef8780"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pdf-page-remover" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-bold" }, "PDF Page Remover", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 mt-2 mb-4" }, "Upload a PDF and remove specific pages", -1))
const _hoisted_4 = { class: "upload-section mb-6" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mx-auto h-12 w-12 text-gray-400",
  stroke: "currentColor",
  fill: "none",
  viewBox: "0 0 48 48"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M28 8H12a4 4 0 00-4 4v24a4 4 0 004 4h24a4 4 0 004-4V20L28 8z",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("polyline", {
    points: "28,8 28,20 40,20",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_7 = { class: "mt-2 text-sm text-slate-400" }
const _hoisted_8 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-block animate-spin rounded-full h-8 w-8 border-4 border-green-500 border-t-transparent" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 mt-2" }, "Loading PDF...", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "max-w-md mx-auto bg-red-50 text-red-600 rounded-lg p-4 mb-4"
}
const _hoisted_13 = {
  key: 2,
  class: "pdf-controls max-w-md mx-auto"
}
const _hoisted_14 = { class: "bg-slate-900 border border-slate-700 rounded-lg p-4 mb-4" }
const _hoisted_15 = { class: "text-lg font-semibold" }
const _hoisted_16 = { class: "text-green-600" }
const _hoisted_17 = { class: "page-selection mb-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block font-medium mb-2 text-left" }, "Pages to remove:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-slate-500 mt-2 text-left" }, " Enter page numbers separated by commas. Use ranges like 5-7 for consecutive pages. Pages can be in any order. ", -1))
const _hoisted_20 = {
  key: 0,
  class: "bg-slate-900 border border-slate-700 rounded-lg p-4 mb-4 text-left"
}
const _hoisted_21 = { class: "text-sm mb-1" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Pages to remove:", -1))
const _hoisted_23 = { class: "text-red-600 font-mono" }
const _hoisted_24 = { class: "text-sm" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Remaining pages:", -1))
const _hoisted_26 = { class: "text-green-600" }
const _hoisted_27 = {
  key: 1,
  class: "bg-green-50 text-green-600 rounded-lg p-4 mb-4"
}
const _hoisted_28 = { class: "flex flex-col sm:flex-row gap-4 justify-center" }
const _hoisted_29 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", {
        class: _normalizeClass(["block w-full max-w-md mx-auto p-6 border-2 border-dashed border-slate-600 rounded-lg cursor-pointer hover:border-green-500 hover:bg-slate-800/50 transition-colors bg-slate-800", { 'border-green-500 bg-slate-800': _ctx.pdfInfo }])
      }, [
        _createElementVNode("input", {
          type: "file",
          ref: "fileInput",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
          accept: ".pdf,application/pdf",
          class: "hidden"
        }, null, 544),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.pdfInfo ? _ctx.pdfInfo.fileName : 'Click to upload PDF'), 1)
        ])
      ], 2)
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
      : _createCommentVNode("", true),
    (_ctx.error && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    (_ctx.pdfInfo && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, [
              _createTextVNode(" Total pages: "),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.pdfInfo.pageCount), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pagesToRemove) = $event)),
              placeholder: "e.g., 1, 3, 5-7, 10, 15",
              class: "w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 text-lg text-slate-200 focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none placeholder-slate-500"
            }, null, 512), [
              [_vModelText, _ctx.pagesToRemove]
            ]),
            _hoisted_19
          ]),
          (_ctx.parsedPages.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("p", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.parsedPages.join(', ')), 1)
                ]),
                _createElementVNode("p", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.pdfInfo.pageCount - _ctx.parsedPages.length), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.successMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.successMessage), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              class: "action-btn bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.processRemovePages && _ctx.processRemovePages(...args))),
              disabled: _ctx.parsedPages.length === 0 || _ctx.isProcessing
            }, _toDisplayString(_ctx.isProcessing ? 'Processing...' : 'Remove Pages'), 9, _hoisted_29),
            (_ctx.downloadUrl)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "action-btn bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg font-medium transition-colors",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.downloadPdf && _ctx.downloadPdf(...args)))
                }, " Download Modified PDF "))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}